import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface DividerProps extends SharedProps {
  variant?: 'soft' | 'medium' | 'hard'
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/divider](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/divider)
 * - Storybook: [Divider](https://designsystem.dn.se/?path=/docs/basic-divider--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/divider/divider.scss'`
 */
export const Divider = ({ variant = 'soft', classNames, attributes }: DividerProps) => {
  const classes = formatClassString(['ds-divider', `ds-divider--${variant}`, classNames])

  return (
    <div className={classes} {...attributes}>
      <hr />
    </div>
  )
}

export default Divider
